// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xbhaqpgbjulugiksptlx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhiaGFxcGdianVsdWdpa3NwdGx4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA5Njg1NTMsImV4cCI6MjA2NjU0NDU1M30.2B0vCRUXf6uGxU2YUrYTF3I-TTrDdey8Gwm4m5gcOig";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);